import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getAutorisatieNiveauTextResources = createGetTextResources({
  ConfirmationTextAutorisatie: `Weet u het zeker? De al ingevoerde gegevens in Instellingen worden
      hierdoor verwijderd.`,
});
